import './Fonts.scss';

export function useSignatureFonts() {
  const fonts = [
    { name: 'Sofia', fontFamily: 'Sofia' },
    { name: 'AguafinaScript', fontFamily: 'AguafinaScript' },
    { name: 'DancingScript', fontFamily: 'DancingScript' },
    { name: 'EuphoriaScript', fontFamily: 'EuphoriaScript' },
    { name: 'LeagueScript', fontFamily: 'LeagueScript' },
    { name: 'GreatVibes', fontFamily: 'GreatVibes' },
  ];

  return fonts;
}
